import { useAuthStore } from '@/stores/auth-store'

export function Header({ title }: { title: string }) {
  const user = useAuthStore((s) => s.user)

  return (
    <header className="flex items-center justify-between border-b border-dashed border-border bg-surface px-8 py-4">
      <h1 className="font-mono text-sm font-medium tracking-wide text-ink">{title}</h1>

      <div className="flex items-center gap-3">
        <div className="text-right">
          <p className="font-mono text-xs text-ink">{user?.name}</p>
          <p className="font-mono text-[10px] text-ink-faint">{user?.email}</p>
        </div>
        <div className="flex h-8 w-8 items-center justify-center rounded-full border border-dashed border-border bg-surface-alt font-mono text-xs font-medium text-ink-muted">
          {user?.name?.charAt(0)?.toUpperCase() ?? '?'}
        </div>
      </div>
    </header>
  )
}
